import { render, staticRenderFns } from "./UebOverview.vue?vue&type=template&id=1a978580&scoped=true&"
import script from "./UebOverview.vue?vue&type=script&lang=js&"
export * from "./UebOverview.vue?vue&type=script&lang=js&"
import style0 from "./UebOverview.vue?vue&type=style&index=0&id=1a978580&scoped=true&lang=css&"
import style1 from "./UebOverview.vue?vue&type=style&index=1&id=1a978580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a978580",
  null
  
)

export default component.exports